import React from 'react';
import { Tag } from 'antd';

const TIER_COLORS = {
  young: 'cyan',
  breeding_ready: 'purple',
  adult_female: 'geekblue',
  adult_male: 'blue',
  aged: 'default',
};

/**
 * Single lifecycle label chip ({ tier, name } or tier + species via parent).
 */
export default function SpeciesLifecycleTierTag({
  tier,
  name,
  color,
  size = 'small',
  ...tagProps
}) {
  if (!name) return null;

  return (
    <Tag color={color ?? TIER_COLORS[tier] ?? 'default'} size={size} {...tagProps}>
      {name}
    </Tag>
  );
}
